// components/CarTile.tsx
import React from "react";
import styles from "./CarTile.module.css";

export function CarTile({ car }) {
  return (
    <div className={styles["car-tile"]}>
      <div
        className={styles["top"]}
        style={{ backgroundColor: car.backgroundColor }}
      >
        <div className={styles["image-wrapper"]}>
          <img
            className={`${styles["car-img"]} ${styles["front-view"]}`}
            src={car.imageFront}
            alt={car.name}
          />
          <img
            className={`${styles["car-img"]} ${styles["side-view"]}`}
            src={car.imageSide}
            alt={`${car.name} Seitenansicht`}
          />
        </div>
      </div>
      <div className={styles["bottom"]}>
        <p className={styles["name"]}>{car.name}</p>
        <p className={styles["price"]}>
          {car.price} <sup>inkl. MwSt.</sup>
        </p>
        <div className={styles["labels"]}>
          <span className={`${styles.label} ${styles.yellow}`}>
            🏷 abzgl. Kaufprämie
          </span>
          <span className={`${styles.label} ${styles.gray}`}>
            🏷 Sondermodell GOAL
          </span>
        </div>
        <button className={styles["model-button"]}>
          Alle Modellvarianten zeigen
        </button>
      </div>
    </div>
  );
}
